
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/virtual-office-forward",
      function () {
        return require("private-next-pages/virtual-office-forward.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/virtual-office-forward"])
      });
    }
  